import { HStack, Stack, StackSeparator } from "@chakra-ui/react-v3";

import { SkeletonCircle, SkeletonText } from "./Skeleton";

export type ListSkeletonProps = {
  /** Number of placeholder rows. Match the expected page size or a typical count. */
  rows?: number;
  /** Text lines per row: a title alone, or a title plus a secondary line. */
  lines?: 1 | 2;
  /** Lead each row with a round placeholder for an avatar, icon, or status dot. */
  leadingCircle?: boolean;
};

/**
 * Placeholder rows for a list that cannot render without data, separated by
 * dividers like the final list. Each row sketches an optional leading circle
 * and one or two text lines. The caller owns the surrounding container and its
 * `aria-busy` state.
 */
export function ListSkeleton(props: ListSkeletonProps) {
  const { rows = 3, lines = 2, leadingCircle = false } = props;

  return (
    <Stack gap="0" separator={<StackSeparator borderColor="border.divider" />}>
      {Array.from({ length: rows }, (_, row) => (
        <HStack key={row} gap="3" py="3">
          {leadingCircle && <SkeletonCircle size="8" />}
          <SkeletonText noOfLines={lines} gap="2" />
        </HStack>
      ))}
    </Stack>
  );
}
